
const seo = [
    // desktop landing
    {
        id: 'd-homepage',
        dest: './build',
        pathname: ['/p2', '/p2/'],
        metaTitle: '雲海別墅 | 新鴻基地產 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此了解更多資訊。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 雲海, st Barths, 豪宅, 白石, 住宅, 馬鞍山住宅, 新鴻基物業, 新鴻基豪宅, 烏溪沙住宅, 新地, 屋仔, 洋房, 海景洋房'
    },
    {
        id: 'd-homepage-en',
        dest: './build/en',
        pathname: ['/p2/en', '/p2/en/'],
        metaTitle: 'Crown of St. Barths | Sun Hung Kai Properties | Luxury Houses & Villas',
        metaDesc: 'Sun Hung Kai Properties Proudly Presents Phase 2 of St. Barths Development - "Crown of St. Barths", precious luxury houses and villas situated in Ma On Shan, located near the cove. Click here to learn more.',
        metaKeywords: 'st Barths, 雲海 st Barths, shk stBarths, shkp st Barths, sun hung kai properties, shkp, home, hong kong property, hong kong homes, ma on shan whitehead'
    },
    {
        id: 'd-homepage-tc',
        dest: './build/tc',
        pathname: ['/p2/tc', '/p2/tc/'],
        metaTitle: '雲海別墅 | 新鴻基地產 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此了解更多資訊。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 雲海, st Barths, 豪宅, 白石, 住宅, 馬鞍山住宅, 新鴻基物業, 新鴻基豪宅, 烏溪沙住宅, 新地, 屋仔, 洋房, 海景洋房'
    },
    {
        id: 'd-homepage-sc',
        dest: './build/sc',
        pathname: ['/p2/sc', '/p2/sc/'],
        metaTitle: '云海别墅 | 新鸿基地产 | 马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此了解更多资讯。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅, 白石角住宅'
    },
    // './build',
    
    // './build/en',
    // './build/tc',
    // './build/sc',

    // desktop EN
    {
        id: 'd-aerial-photograph-en',
        dest: './build/en/aerial-photograph',
        pathname: ['/p2/en/aerial-photograph', '/p2/en/aerial-photograph/'],
        metaTitle: 'Crown of St. Barths | Aerial Photograph | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Aerial Photographs ',
        metaKeywords: 'st Barths, shk stBarths, sun hung kai properties, shkp,shkp development'
    },
    {
        id: 'd-announcement-en',
        dest: './build/en/announcement',
        pathname: ['/p2/en/announcement', '/p2/en/announcement/'],
        metaTitle: 'Crown of St. Barths | Announcement | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Announcement',
        metaKeywords: 'st Barths, shk stBarths, sun hung kai properties, shkp, home, hong kong property, hong kong homes, property sales announcement'
    },
    {
        id: 'd-deed-of-mutual-covenant-en',
        dest: './build/en/deed-of-mutual-covenant',
        pathname: ['/p2/en/deed-of-mutual-covenant', '/p2/en/deed-of-mutual-covenant/'],
        metaTitle: 'Crown of St. Barths | DMC | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  DMC',
        metaKeywords: 'st Barths, shk stBarths, sun hung kai properties, shkp, home, hong kong property, hong kong homes, '
    },
    {
        id: 'd-gallery-en',
        dest: './build/en/gallery',
        pathname: ['/p2/en/gallery', '/p2/en/gallery/'],
        metaTitle: 'Crown of St. Barths | Photo Gallery | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Gallery',
        metaKeywords: 'st Barths, shk stBarths, shkp, Luxury Real Estate, Ma On Shan houses'
    },
    {
        id: 'd-price-list-en',
        dest: './build/en/price-list',
        pathname: ['/p2/en/price-list', '/p2/en/price-list/'],
        metaTitle: 'Crown of St. Barths | Price List | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Price List',
        metaKeywords: 'hong kong property prices, real estate agent, st Barths, shk st Barths, 雲海 st Barths, st Barths price, shk st Barths price, hong kong apartment, apartment, apartment price'
    },
    {
        id: 'd-register-of-transactions-en',
        dest: './build/en/register-of-transactions',
        pathname: ['/p2/en/register-of-transactions', '/p2/en/register-of-transactions/'],
        metaTitle: 'Crown of St. Barths | ROT | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Register Of Transactions',
        metaKeywords: 'hong kong property prices, real estate agent, st Barths, shk st Barths, st Barths price, property'
    },
    {
        id: 'd-sales-arrangements-en',
        dest: './build/en/sales-arrangements',
        pathname: ['/p2/en/sales-arrangements', '/p2/en/sales-arrangements/'],
        metaTitle: 'Crown of St. Barths | Sales Arrangements | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Sales Arrangements',
        metaKeywords: 'shk, shk st Barths, st Barths, 雲海 st Barths, real estate agent, st Barths sale, shk property sale'
    },
    {
        id: 'd-sales-brochure-en',
        dest: './build/en/sales-brochure',
        pathname: ['/p2/en/sales-brochure', '/p2/en/sales-brochure/'],
        metaTitle: 'Crown of St. Barths | Sales Brochure | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Sales Brochure',
        metaKeywords: 'Pak Shek Kok st Barths, shk, shk st Barths, st Barths, 雲海 st Barths, hong kong property, hong kong property sale'
    },
    {
        id: 'd-tender-documents-en',
        dest: './build/en/tender-documents',
        pathname: ['/p2/en/tender-documents', '/p2/en/tender-documents/'],
        metaTitle: 'Crown of St. Barths | Tender Documents | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Sales Brochure',
        metaKeywords: 'Pak Shek Kok st Barths, shk, shk st Barths, st Barths, 雲海 st Barths, hong kong property, hong kong property sale'
    },

    // './build/en/sales-brochure',
    // './build/en/price-list',
    // './build/en/sales-arrangements',
    // './build/en/register-of-transactions',
    // './build/en/deed-of-mutual-covenant',
    // './build/en/aerial-photograph',
    // './build/en/announcement',
    // './build/en/gallery',


    // desktop TC
    {
        id: 'd-aerial-photograph-tc',
        dest: './build/tc/aerial-photograph',
        pathname: ['/p2/tc/aerial-photograph', '/p2/tc/aerial-photograph/'],
        metaTitle: '雲海別墅 | 鳥瞰照片 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽鳥瞰照片。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 洋房, 白石, 白石交通, 馬鞍山'
    },
    {
        id: 'd-announcement-tc',
        dest: './build/tc/announcement',
        pathname: ['/p2/tc/announcement', '/p2/tc/announcement/'],
        metaTitle: '雲海別墅 | 最新消息 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽最新消息。',
        metaKeywords: '新鴻基, 馬鞍山白石, 樓盤, 樓盤消息, 樓盤銷售, 高爾夫球場'
    },
    {
        id: 'd-deed-of-mutual-covenant-tc',
        dest: './build/tc/deed-of-mutual-covenant',
        pathname: ['/p2/tc/deed-of-mutual-covenant', '/p2/tc/deed-of-mutual-covenant/'],
        metaTitle: '雲海別墅 | 公契 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽公契資料。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 馬鞍山白石, 馬鞍山交通, 置業'
    },
    {
        id: 'd-gallery-tc',
        dest: './build/tc/gallery',
        pathname: ['/p2/tc/gallery', '/p2/tc/gallery/'],
        metaTitle: '雲海別墅  | 相集 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽相關圖像。',
        metaKeywords: '白石, 耀沙路, 吐露港海景, 馬鞍山, 豪宅'
    },
    {
        id: 'd-price-list-tc',
        dest: './build/tc/price-list',
        pathname: ['/p2/tc/price-list', '/p2/tc/price-list/'],
        metaTitle: '雲海別墅  | 價單 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此瀏覽價單。',
        metaKeywords: '雲海價單,雲海, st Barths, 地產, 雲海開售, 馬鞍山, 新鴻基, 豪宅, 置業,樓盤, 雲海售價, st Barths 售價,香港地產, 香港物業, 香港房地產,海景戶,雲海新鴻基,科學園'
    },
    {
        id: 'd-register-of-transactions-tc',
        dest: './build/tc/register-of-transactions',
        pathname: ['/p2/tc/register-of-transactions', '/p2/tc/register-of-transactions/'],
        metaTitle: '雲海別墅  | 成交記錄冊 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此瀏覽成交記錄冊。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 馬鞍山, 白石角, 新盤, 雲海成交, St Barths, 樓盤,成交,置業,科學園'
    },
    {
        id: 'd-sales-arrangements-tc',
        dest: './build/tc/sales-arrangements',
        pathname: ['/p2/tc/sales-arrangements', '/p2/tc/sales-arrangements/'],
        metaTitle: '雲海別墅  | 銷售安排 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此瀏覽銷售安排。',
        metaKeywords: '雲海, st Barths, 地產,  雲海銷售, 雲海銷情, 雲海出售, 烏溪沙, 新鴻基, 豪宅, 物業, 馬鞍山 住宅, 置業,樓宇買賣,科學園'
    },
    {
        id: 'd-sales-brochure-tc',
        dest: './build/tc/sales-brochure',
        pathname: ['/p2/tc/sales-brochure', '/p2/tc/sales-brochure/'],
        metaTitle: '雲海別墅  | 售樓說明書 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此下載售樓說明書。',
        metaKeywords: '雲海, st Barths, 新鴻基, 豪宅, 物業, 新鴻基物業, 新鴻基豪宅, 雲海銷售, 新鴻基物業銷售,成交紀錄,科學園'
    },
    {
        id: 'd-tender-documents-tc',
        dest: './build/tc/tender-documents',
        pathname: ['/p2/tc/tender-documents', '/p2/tc/tender-documents/'],
        metaTitle: '雲海別墅  | 招標文件 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此下載售樓說明書。',
        metaKeywords: '雲海, st Barths, 新鴻基, 豪宅, 物業, 新鴻基物業, 新鴻基豪宅, 雲海銷售, 新鴻基物業銷售,成交紀錄,科學園'
    },
    // './build/tc/sales-brochure',
    // './build/tc/price-list',
    // './build/tc/sales-arrangements',
    // './build/tc/register-of-transactions',
    // './build/tc/deed-of-mutual-covenant',
    // './build/tc/aerial-photograph',
    // './build/tc/announcement',
    // './build/tc/gallery',


    // desktop TC
    {
        id: 'd-aerial-photograph-sc',
        dest: './build/sc/aerial-photograph',
        pathname: ['/p2/sc/aerial-photograph', '/p2/sc/aerial-photograph/'],
        metaTitle: '云海别墅 | 鸟瞰照片 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览鸟瞰照片。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅'
    },
    {
        id: 'd-announcement-sc',
        dest: './build/sc/announcement',
        pathname: ['/p2/sc/announcement', '/p2/sc/announcement/'],
        metaTitle: '云海别墅| 最新消息 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览最新消息。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅, 新鸿基地产销售情况'
    },
    {
        id: 'd-deed-of-mutual-covenant-sc',
        dest: './build/sc/deed-of-mutual-covenant',
        pathname: ['/p2/sc/deed-of-mutual-covenant', '/p2/sc/deed-of-mutual-covenant/'],
        metaTitle: '云海别墅 | 公契 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览公契资料。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, 新鸿基豪宅, shkp, 豪宅, 白石角, 住宅'
    },
    {
        id: 'd-gallery-sc',
        dest: './build/sc/gallery',
        pathname: ['/p2/sc/gallery', '/p2/sc/gallery/'],
        metaTitle: '云海别墅 | 相集 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览相关图像。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅'
    },
    {
        id: 'd-price-list-sc',
        dest: './build/sc/price-list',
        pathname: ['/p2/sc/price-list', '/p2/sc/price-list/'],
        metaTitle: '云海别墅 | 价单 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此浏览价单。',
        metaKeywords: '云海价单,云海, st Barths, 地产, 云海开售, 马鞍山, 新鸿基, 豪宅, 置业,楼盘, 云海售价, st Barths 售价,香港地产, 香港物业, 香港房地产,海景户,云海新鸿基,科学园'
    },
    {
        id: 'd-register-of-transactions-sc',
        dest: './build/sc/register-of-transactions',
        pathname: ['/p2/sc/register-of-transactions', '/p2/sc/register-of-transactions/'],
        metaTitle: '云海别墅 | 成交记录册 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此浏览成交记录册。',
        metaKeywords: '新鸿基, 新鸿基地产, shkp, 马鞍山, 白石角, 新盘, 云海成交, St Barths, 楼盘,成交,置业,科学园'
    },
    {
        id: 'd-sales-arrangements-sc',
        dest: './build/sc/sales-arrangements',
        pathname: ['/p2/sc/sales-arrangements', '/p2/sc/sales-arrangements/'],
        metaTitle: '云海别墅 | 销售安排 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此浏览销售安排。',
        metaKeywords: '云海, st Barths, 地产, 云海销售, 云海销情, 云海出售, 乌溪沙, 新鸿基, 豪宅, 物业, 马鞍山 住宅, 置业,楼宇买卖,科学园'
    },
    {
        id: 'd-sales-brochure-sc',
        dest: './build/sc/sales-brochure',
        pathname: ['/p2/sc/sales-brochure', '/p2/sc/sales-brochure/'],
        metaTitle: '云海别墅| 售楼说明书 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此下载售楼说明书。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 白石角st Barths, 大埔白石角云海, 地产, 科学园, 新鸿基, 全新住宅楼盘,科学园'
    },
    {
        id: 'd-tender-documents-sc',
        dest: './build/sc/tender-documents',
        pathname: ['/p2/sc/tender-documents', '/p2/sc/tender-documents/'],
        metaTitle: '云海别墅| 招标文件 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此下载售楼说明书。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 白石角st Barths, 大埔白石角云海, 地产, 科学园, 新鸿基, 全新住宅楼盘,科学园'
    },
    // './build/sc/sales-brochure',
    // './build/sc/price-list',
    // './build/sc/sales-arrangements',
    // './build/sc/register-of-transactions',
    // './build/sc/deed-of-mutual-covenant',
    // './build/sc/aerial-photograph',
    // './build/sc/announcement',
    // './build/sc/gallery',


    // mobile landing
    {
        id: 'm-homepage',
        dest: './build/m',
        metaTitle: '雲海別墅 | 新鴻基地產 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此了解更多資訊。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 雲海, st Barths, 豪宅, 白石, 住宅, 馬鞍山住宅, 新鴻基物業, 新鴻基豪宅, 烏溪沙住宅, 新地, 屋仔, 洋房, 海景洋房'
    },
    {
        id: 'm-homepage-en',
        dest: './build/m/en',
        metaTitle: 'Crown of St. Barths | Sun Hung Kai Properties | Luxury Houses & Villas',
        metaDesc: 'Sun Hung Kai Properties Proudly Presents Phase 2 of St. Barths Development - "Crown of St. Barths", precious luxury houses and villas situated in Ma On Shan, located near the cove. Click here to learn more.',
        metaKeywords: 'st Barths, 雲海 st Barths, shk stBarths, shkp st Barths, sun hung kai properties, shkp, home, hong kong property, hong kong homes, ma on shan whitehead'
    },
    {
        id: 'm-homepage-tc',
        dest: './build/m/tc',
        metaTitle: '雲海別墅 | 新鴻基地產 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此了解更多資訊。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 雲海, st Barths, 豪宅, 白石, 住宅, 馬鞍山住宅, 新鴻基物業, 新鴻基豪宅, 烏溪沙住宅, 新地, 屋仔, 洋房, 海景洋房'
    },
    {
        id: 'm-homepage-sc',
        dest: './build/m/sc',
        metaTitle: '云海别墅 | 新鸿基地产 | 马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此了解更多资讯。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅, 白石角住宅'
    },
    // './build/m',
    
    // './build/m/en',
    // './build/m/tc',
    // './build/m/sc',

    // mobile EN
    {
        id: 'm-aerial-photograph-en',
        dest: './build/m/en/aerial-photograph',
        metaTitle: 'Crown of St. Barths | Aerial Photograph | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Aerial Photographs ',
        metaKeywords: 'st Barths, shk stBarths, sun hung kai properties, shkp,shkp development'
    },
    {
        id: 'm-announcement-en',
        dest: './build/m/en/announcement',
        metaTitle: 'Crown of St. Barths | Announcement | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Announcement',
        metaKeywords: 'st Barths, shk stBarths, sun hung kai properties, shkp, home, hong kong property, hong kong homes, property sales announcement'
    },
    {
        id: 'm-deed-of-mutual-covenant-en',
        dest: './build/m/en/deed-of-mutual-covenant',
        metaTitle: 'Crown of St. Barths | DMC | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  DMC',
        metaKeywords: 'st Barths, shk stBarths, sun hung kai properties, shkp, home, hong kong property, hong kong homes, '
    },
    {
        id: 'm-gallery-en',
        dest: './build/m/en/gallery',
        metaTitle: 'Crown of St. Barths | Photo Gallery | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Gallery',
        metaKeywords: 'st Barths, shk stBarths, shkp, Luxury Real Estate, Ma On Shan houses'
    },
    {
        id: 'm-price-list-en',
        dest: './build/m/en/price-list',
        metaTitle: 'Crown of St. Barths | Price List | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Price List',
        metaKeywords: 'hong kong property prices, real estate agent, st Barths, shk st Barths, 雲海 st Barths, st Barths price, shk st Barths price, hong kong apartment, apartment, apartment price'
    },
    {
        id: 'm-register-of-transactions-en',
        dest: './build/m/en/register-of-transactions',
        metaTitle: 'Crown of St. Barths | ROT | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Register Of Transactions',
        metaKeywords: 'hong kong property prices, real estate agent, st Barths, shk st Barths, st Barths price, property'
    },
    {
        id: 'm-sales-arrangements-en',
        dest: './build/m/en/sales-arrangements',
        metaTitle: 'Crown of St. Barths | Sales Arrangements | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Sales Arrangements',
        metaKeywords: 'shk, shk st Barths, st Barths, 雲海 st Barths, real estate agent, st Barths sale, shk property sale'
    },
    {
        id: 'm-sales-brochure-en',
        dest: './build/m/en/sales-brochure',
        metaTitle: 'Crown of St. Barths | Sales Brochure | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Sales Brochure',
        metaKeywords: 'Pak Shek Kok st Barths, shk, shk st Barths, st Barths, 雲海 st Barths, hong kong property, hong kong property sale'
    },
    {
        id: 'm-tender-documents-en',
        dest: './build/m/en/tender-documents',
        metaTitle: 'Crown of St. Barths | Tender Documents | Sun Hung Kai Properties',
        metaDesc: 'Phase 2 of St Barths Development "Crown of St. Barths" -  Sales Brochure',
        metaKeywords: 'Pak Shek Kok st Barths, shk, shk st Barths, st Barths, 雲海 st Barths, hong kong property, hong kong property sale'
    },

    // './build/m/en/sales-brochure',
    // './build/m/en/price-list',
    // './build/m/en/sales-arrangements',
    // './build/m/en/register-of-transactions',
    // './build/m/en/deed-of-mutual-covenant',
    // './build/m/en/aerial-photograph',
    // './build/m/en/announcement',
    // './build/m/en/gallery',




    // mobile TC
    {
        id: 'm-aerial-photograph-tc',
        dest: './build/m/tc/aerial-photograph',
        metaTitle: '雲海別墅 | 鳥瞰照片 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽鳥瞰照片。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 洋房, 白石, 白石交通, 馬鞍山'
    },
    {
        id: 'm-announcement-tc',
        dest: './build/m/tc/announcement',
        metaTitle: '雲海別墅 | 最新消息 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽最新消息。',
        metaKeywords: '新鴻基, 馬鞍山白石, 樓盤, 樓盤消息, 樓盤銷售, 高爾夫球場'
    },
    {
        id: 'm-deed-of-mutual-covenant-tc',
        dest: './build/m/tc/deed-of-mutual-covenant',
        metaTitle: '雲海別墅 | 公契 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽公契資料。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 馬鞍山白石, 馬鞍山交通, 置業'
    },
    {
        id: 'm-gallery-tc',
        dest: './build/m/tc/gallery',
        metaTitle: '雲海別墅 | 相集 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』由 67 幢洋房組成，實用面積由約2,000至4,000平方呎不等。間隔多元，提供三房至四房單位。按此瀏覽相關圖像。',
        metaKeywords: '白石, 耀沙路, 吐露港海景, 馬鞍山, 豪宅'
    },
    {
        id: 'm-price-list-tc',
        dest: './build/m/tc/price-list',
        metaTitle: '雲海別墅 | 價單 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此瀏覽價單。',
        metaKeywords: '雲海價單,雲海, st Barths, 地產, 雲海開售, 馬鞍山, 新鴻基, 豪宅, 置業,樓盤, 雲海售價, st Barths 售價,香港地產, 香港物業, 香港房地產,海景戶,雲海新鴻基,科學園'
    },
    {
        id: 'm-register-of-transactions-tc',
        dest: './build/m/tc/register-of-transactions',
        metaTitle: '雲海別墅 | 成交記錄冊 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此瀏覽成交記錄冊。',
        metaKeywords: '新鴻基, 新鴻基地產, shkp, 馬鞍山, 白石角, 新盤, 雲海成交, St Barths, 樓盤,成交,置業,科學園'
    },
    {
        id: 'm-sales-arrangements-tc',
        dest: './build/m/tc/sales-arrangements',
        metaTitle: '雲海別墅 | 銷售安排 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此瀏覽銷售安排。',
        metaKeywords: '雲海, st Barths, 地產,  雲海銷售, 雲海銷情, 雲海出售, 烏溪沙, 新鴻基, 豪宅, 物業, 馬鞍山 住宅, 置業,樓宇買賣,科學園'
    },
    {
        id: 'm-sales-brochure-tc',
        dest: './build/m/tc/sales-brochure',
        metaTitle: '雲海別墅 | 售樓說明書 | 馬鞍山白石低密度海景洋房',
        metaDesc: '雲海發展項目第二期之『雲海別墅』將提供港鐵站沿綫極為罕見的低密度海景洋房。除坐擁雙面迷人海景，亦盡享完善交通網絡優勢，佔盡地利先機。按此下載售樓說明書。',
        metaKeywords: '雲海, st Barths, 新鴻基, 豪宅, 物業, 新鴻基物業, 新鴻基豪宅, 雲海銷售, 新鴻基物業銷售,成交紀錄,科學園'
    },
    {
        id: 'm-tender-documents-tc',
        dest: './build/m/tc/tender-documents',
        metaTitle: '云海别墅 | 招標文件 | 马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此下载售楼说明书。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 白石角st Barths, 大埔白石角云海, 地产, 科学园, 新鸿基, 全新住宅楼盘,科学园'
    },
    // './build/m/tc/sales-brochure',
    // './build/m/tc/price-list',
    // './build/m/tc/sales-arrangements',
    // './build/m/tc/register-of-transactions',
    // './build/m/tc/deed-of-mutual-covenant',
    // './build/m/tc/aerial-photograph',
    // './build/m/tc/announcement',
    // './build/m/tc/gallery',


    // mobile SC
    {
        id: 'm-aerial-photograph-sc',
        dest: './build/m/sc/aerial-photograph',
        metaTitle: '云海别墅 | 鸟瞰照片 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览鸟瞰照片。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅'
    },
    {
        id: 'm-announcement-sc',
        dest: './build/m/sc/announcement',
        metaTitle: '云海别墅 | 最新消息 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览最新消息。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅, 新鸿基地产销售情况'
    },
    {
        id: 'm-deed-of-mutual-covenant-sc',
        dest: './build/m/sc/deed-of-mutual-covenant',
        metaTitle: '云海别墅 | 公契 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览公契资料。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, 新鸿基豪宅, shkp, 豪宅, 白石角, 住宅'
    },
    {
        id: 'm-gallery-sc',
        dest: './build/m/sc/gallery',
        metaTitle: '云海别墅 | 相集 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』由 67 幢洋房组成，实用面积由约2,000至4,000平方呎不等。间隔多元，提供三房至四房单位。按此浏览相关图像。',
        metaKeywords: '云海, st Barths, 新鸿基, 新鸿基地产, shkp, 豪宅, 白石角, 住宅'
    },
    {
        id: 'm-price-list-sc',
        dest: './build/m/sc/price-list',
        metaTitle: '云海别墅 | 价单 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此浏览价单。',
        metaKeywords: '云海价单,云海, st Barths, 地产, 云海开售, 马鞍山, 新鸿基, 豪宅, 置业,楼盘, 云海售价, st Barths 售价,香港地产, 香港物业, 香港房地产,海景户,云海新鸿基,科学园'
    },
    {
        id: 'm-register-of-transactions-sc',
        dest: './build/m/sc/register-of-transactions',
        metaTitle: '云海别墅 | 成交记录册 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此浏览成交记录册。',
        metaKeywords: '新鸿基, 新鸿基地产, shkp, 马鞍山, 白石角, 新盘, 云海成交, St Barths, 楼盘,成交,置业,科学园'
    },
    {
        id: 'm-sales-arrangements-sc',
        dest: './build/m/sc/sales-arrangements',
        metaTitle: '云海别墅 | 销售安排 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此浏览销售安排。',
        metaKeywords: '云海, st Barths, 地产, 云海销售, 云海销情, 云海出售, 乌溪沙, 新鸿基, 豪宅, 物业, 马鞍山 住宅, 置业,楼宇买卖,科学园'
    },
    {
        id: 'm-sales-brochure-sc',
        dest: './build/m/sc/sales-brochure',
        metaTitle: '云海别墅 | 售楼说明书 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此下载售楼说明书。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 白石角st Barths, 大埔白石角云海, 地产, 科学园, 新鸿基, 全新住宅楼盘,科学园'
    },
    {
        id: 'm-tender-documents-sc',
        dest: './build/m/sc/tender-documents',
        metaTitle: '云海别墅 | 招标文件 |  马鞍山白石低密度海景洋房',
        metaDesc: '云海发展项目第二期之『云海别墅』将提供港铁站沿线极为罕见的低密度海景洋房。除坐拥双面迷人海景，亦尽享完善交通网络优势，占尽地利先机。按此下载售楼说明书。',
        metaKeywords: '云海, st Barths, 云海 st Barths, 白石角st Barths, 大埔白石角云海, 地产, 科学园, 新鸿基, 全新住宅楼盘,科学园'
    },
    // './build/m/sc/sales-brochure',
    // './build/m/sc/price-list',
    // './build/m/sc/sales-arrangements',
    // './build/m/sc/register-of-transactions',
    // './build/m/sc/deed-of-mutual-covenant',
    // './build/m/sc/aerial-photograph',
    // './build/m/sc/announcement',
    // './build/m/sc/gallery',
]

export default seo


// WEBPACK FOOTER //
// ./src/config/seo.js